import { ACTIONS } from "UTILS/Constants";

const initialState = {
  snapshotCanvas: {},
  snapshotCanvasData: null,
  lastDrawnObject: null,
  ownerOfLastAction: null,
  isSnapshotRunning: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SNAPSHOT.SET_SNAPSHOT_STATUS:
      return { ...state, isSnapshotRunning: action.value }

    case ACTIONS.SNAPSHOT.ADD_CANVAS:
      return {...state, snapshotCanvas: action.newCanvas}

    case ACTIONS.SNAPSHOT.DELETE_CANVAS:
      return initialState

    case ACTIONS.SNAPSHOT.CLEAR_CANVAS:
      return {
        ...state,
        lastDrawnObject: null,
        snapshotCanvasData: null,
        ownerOfLastAction: null
      }

    case ACTIONS.SNAPSHOT.ADD_OBJECT:
      let canvasData = _.cloneDeep(state.snapshotCanvasData || {});
      canvasData[action.data.whiteboardData.objectId] = {}
      canvasData[action.data.whiteboardData.objectId].participantId = action.data.participantId
      canvasData[action.data.whiteboardData.objectId].canvasData =
            action.data.whiteboardData;
      return {
        ...state,
        snapshotCanvasData: canvasData,
        lastDrawnObject: action.data.whiteboardData,
        ownerOfLastAction: action.data.participantId
      };

    default:
      return state;
  }
}
